export type AssistantClientFailureReason = "auth_timeout" | "auth" | "network" | "http" | "invalid_response" | "interrupted_stream" | "protocol" | "timeout";
export type AssistantClientFailureStage = "authentication" | "request" | "response" | "stream";

/** Only fixed classifications cross the transport boundary; provider bodies,
 * browser errors and credentials never become display or telemetry text. */
export class AssistantClientError extends Error {
  constructor(
    readonly reason: AssistantClientFailureReason,
    readonly stage: AssistantClientFailureStage,
    readonly status?: number,
    message = "Assistant request failed",
  ) {
    super(message);
    this.name = "AssistantClientError";
  }
}

export function isAssistantClientError(error: unknown): error is AssistantClientError {
  return error instanceof AssistantClientError;
}
